import { useState } from 'react';
import { Mail, ArrowRight, Loader2 } from 'lucide-react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { toast } from 'sonner';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const NewsletterForm = ({ variant = 'default' }) => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email) return;

    setLoading(true);
    try {
      await axios.post(`${API}/newsletter/subscribe`, { email });
      toast.success('Successfully subscribed!', {
        description: 'Thank you for joining our newsletter.',
      });
      setEmail('');
    } catch (error) {
      toast.error('Subscription failed', {
        description: 'Please try again later.',
      });
    } finally {
      setLoading(false);
    }
  };

  if (variant === 'footer') {
    return (
      <form onSubmit={handleSubmit} className="flex gap-2" data-testid="newsletter-form-footer">
        <Input
          type="email"
          placeholder="Your email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="bg-white/10 border-white/20 text-white placeholder:text-white/50 rounded-lg"
          data-testid="newsletter-email-footer"
          required
        />
        <Button 
          type="submit" 
          disabled={loading}
          className="bg-white text-countryside-green hover:bg-white/90 rounded-lg px-4"
          data-testid="newsletter-submit-footer"
        >
          {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : <ArrowRight className="w-4 h-4" />}
        </Button>
      </form>
    );
  }

  return (
    <form onSubmit={handleSubmit} className="flex flex-col sm:flex-row gap-3 max-w-md mx-auto" data-testid="newsletter-form">
      <div className="relative flex-1">
        <Mail className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-muted-foreground" />
        <Input
          type="email"
          placeholder="Enter your email address"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="pl-12 h-12 rounded-xl border-stone-200"
          data-testid="newsletter-email"
          required
        />
      </div>
      <Button 
        type="submit" 
        disabled={loading}
        className="h-12 px-8 bg-countryside-green hover:bg-countryside-green-dark text-white rounded-xl"
        data-testid="newsletter-submit"
      >
        {loading ? (
          <Loader2 className="w-5 h-5 animate-spin" />
        ) : (
          <>
            Subscribe
            <ArrowRight className="w-4 h-4 ml-2" />
          </>
        )}
      </Button>
    </form>
  );
};
